// extracted by mini-css-extract-plugin
export default {"root":"uy_xY9GQIzZB7JeKwKyn","placeHolderShimmer":"usRibJZuk0USto2tTAjw"};